import script from "./ArrowDownIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrowDownIcon.vue?vue&type=script&setup=true&lang=js"

import "./ArrowDownIcon.vue?vue&type=style&index=0&id=4e84f1af&lang=css"

export default script